import { Business } from "@turizi/shared";

export const HotelTemplate: Partial<Business> = {
    category: 'hotel',

    self_attrs: [
        {
            key: 'stars',
            type: 'text',
            value: null,
            placeholder: '1,2,3,4,5',
            section: 'category_1',
        },
        {
            key: 'regime',
            type: 'text',
            value: null,
            options: ['All Inclusive', 'Media Pension', 'Pension Completa', 'Desayuno', 'Sin Regimen'],
            section: 'category_1',
        },
        {
            key: 'swimming_pool',
            type: 'boolean',
            value: false,
            section: 'amenities_2',
            sort: 1,
        },
        {
            key: 'gym',
            type: 'boolean',
            value: false,
            section: 'amenities_2',
            sort: 2,
        },
        {
            key: 'wifi',
            type: 'boolean',
            value: true,
            section: 'amenities_2',
        },
        {
            key: 'parking',
            type: 'boolean',
            value: false,
            section: 'services_3',
        },
        {
            key: 'business_center',
            type: 'boolean',
            value: false,
            section: 'services_3',
        },
        {
            key: 'restaurant',
            type: 'boolean',
            value: false,
            section: 'services_3',
        },
        {
            key: 'check_in',
            type: 'text',
            value: '14:00',
            section: 'policies_4',
        },
        {
            key: 'check_out',
            type: 'text',
            value: '11:00',
            section: 'policies_4',
        },
    ]

} as const;

export default HotelTemplate;